import { render, staticRenderFns } from "./CreateNewVersionModal.vue?vue&type=template&id=68240294&scoped=true&"
import script from "./CreateNewVersionModal.vue?vue&type=script&lang=ts&"
export * from "./CreateNewVersionModal.vue?vue&type=script&lang=ts&"
import style0 from "./CreateNewVersionModal.vue?vue&type=style&index=0&id=68240294&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68240294",
  null
  
)

export default component.exports